module.exports = __webpack_public_path__ + "static/media/J-Diamond.ec6982be.svg";